import { DateTime } from 'luxon';
import cloneDateTime from './cloneDateTime';
import toISOMonthString from './toISOMonthString';

export default function getVisibleDays(
  month,
  numberOfMonths,
  enableOutsideDays,
  withoutTransitionMonths,
) {
  if (!(month instanceof DateTime)) return {};

  const visibleDaysByMonth = {};
  let currentMonth = withoutTransitionMonths ? cloneDateTime(month) : cloneDateTime(month).minus({ months: 1 });

  for (let i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
    const visibleDays = [];

    // set utc offset to get correct dates in future (when timezone changes)
    const baseDate = cloneDateTime(currentMonth);
    const firstOfMonth = cloneDateTime(baseDate).startOf('month').set({ hours: 12 });
    const lastOfMonth = cloneDateTime(baseDate).endOf('month').set({ hours: 12 });

    let currentDay = cloneDateTime(firstOfMonth);

   // days belonging to the previous month
    if (enableOutsideDays) {
      for (let j = 0; j < currentDay.weekday; j += 1) {
        const prevDay = cloneDateTime(currentDay).minus({ days: j + 1 });
        visibleDays.unshift(prevDay);
      }
    }

    while (currentDay < lastOfMonth) {
      visibleDays.push(cloneDateTime(currentDay));
      currentDay = currentDay.plus({ days: 1 });
    }

    if (enableOutsideDays) {
      if (currentDay.weekday !== 0) {
        // days belonging to the next month
        for (let k = currentDay.weekday, count = 0; k < 7; k += 1, count += 1) {
          const nextDay = cloneDateTime(currentDay).plus({ days: count });
          visibleDays.push(nextDay);
        }
      }
    }

    visibleDaysByMonth[toISOMonthString(currentMonth)] = visibleDays;
    currentMonth = cloneDateTime(currentMonth).plus({ months: 1 });
  }

  return visibleDaysByMonth;
}
